import styled from "styled-components";

export const ModalBody = styled.div`
  text-align: center;
`;

export const Icone = styled.div`
  margin: auto;
  font-size: 30px;

  svg {
    background-color: #e5fff8;
    color: #10ac85;
    border-radius: 10px;
    padding: 4px;
  }
`;
